<template>
  <div>
    <div class="px-4 pt-4 pb-2">
      <b-button
        variant="ghost"
        class="border bg-white text-secondary rounded-pill d-inline-flex align-items-center mb-3"
        @click="handleBackButton"
        :disabled="storeDineInLoading || branchesLoading"
      >
        <img
          src="@/assets/images/actions/arrow-back.svg"
          alt="Back"
          class="mr-2"
        />
        Back
      </b-button>
    </div>
    <h5 class="border-bottom px-4 pb-3 mb-0">Update Table Group</h5>
    <div
      id="table-update-form-container"
      class="bg-white p-4 h-100 position-relative"
    >
      <DineInTableGroupForm />
    </div>
    <DineInFormFooter />
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  computed,
  watch,
} from "@vue/composition-api";
import DineInTableGroupForm from "../../../components/store/dine-in/DineInTableGroupForm.vue";
import DineInFormFooter from "../../../components/store/dine-in/DineInFormFooter.vue";

export default defineComponent({
  components: { DineInTableGroupForm, DineInFormFooter },
  setup(_, { root }) {
    const storeDineInLoading = computed(
      () => root.$store.state.storeDineIn.loading
    );
    const branchesLoading = computed(() => root.$store.state.branches.loading);
    const handleBackButton = () => {
      root.$emit("isUntouchedForm");
    };

    onMounted(async () => {
      const uuid = root.$route.params.uuid || null;
      if (uuid) await root.$store.dispatch("storeDineIn/viewGroupTable", uuid);
      else root.$router.push({ name: "DineInList" });
    });

    onBeforeUnmount(() => {
      root.$store.commit("storeDineIn/setTableData", null);
    });

    watch(branchesLoading, () => {
      const displayValue = branchesLoading.value ? "flex" : "none";
      document.documentElement.style.setProperty(
        "--form-setup-display",
        displayValue
      );
    });

    return {
      handleBackButton,
      storeDineInLoading,
      branchesLoading,
    };
  },
});
</script>

<style lang="scss" scoped>
#table-update-form-container::after {
  content: "Please wait while we're setting things up...";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.85);
  padding: 5rem 0;
  justify-content: center;
  display: var(--form-setup-display);
}
</style>
